import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Grow from "@material-ui/core/Grow";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import Table from "@material-ui/core/Table";
import Tooltip from "@material-ui/core/Tooltip";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SearchIcon from "@material-ui/icons/Search";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import { getFormattedDate, getFormattedTimeFromDate } from "Utils";
import { Redirect, Route, Switch } from "react-router-dom";
import CallOutNew from "Component/Headers/callOutNew";
import CustomLoader from "Component/CustomLoader";

import TextField from "@material-ui/core/TextField";
import {
  setSaveProgress,
  removeSaveProgress,
} from "Actions/SaveProgressAction";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import { RightDrawer, setHelperText } from "../../../Actions/commonAction";
import defaultEmp from "../../../Assets/Images/defaultEmp.svg";
import { getFormattedImageLink } from "../../../Utils";
import AddDeviceComponent from "./AddDevice";
import DeviceDetails from "./DeviceDetails";
import DeviceGroup from "./DeviceGroup";
import DevicePingAlert from "./DevicePingAlert";
import DeviceRowData from "./DeviceRawData";
import "./index.css";
import DrawerHeader from "Component/Headers/drawerHeader";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import DynamicForm from "Component/DynamicForm";
import clipListEmpty from "Assets/Images/clip-list-is-empty.png";

const directions = [
  { displayvalue: 1, displayname: "Only IN" },
  { displayvalue: 2, displayname: "Only OUT" },
  { displayvalue: 3, displayname: "Both IN & OUT" },
];

const menuActions = [
  {
    id: 1,
    name: "View Details",
  },
  {
    id: 2,
    name: "Edit Details",
  },
  // {
  //   id: 1,
  //   name: "Device Details",
  // },
  // {
  //   id: 2,
  //   name: "Device Ping Alerts",
  // },
  // {
  //   id: 3,
  //   name: "Download Raw Data",
  // },
  // {
  //   id: 4,
  //   name: "Download Deviec Info",
  // },
];

class BioMetric extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceList: [],
      tempList: [],
      menuopen: false,
      open: false,
      menu: null,
      currentdevice: null,
      pingalerts: null,
      devicegroups: null,
      currentgroup: null,
      devicegroupList: null,
      selecteddevicegroup: null,
      datarcv2: false,
      datarcv1: false,
      datareceived: false,
      locationlist: [],
      infodrawer: false,
      isEdit: false,
      postData: {
        devicename: null,
        devicedirectionid: null,
        deviceserialnumber: null,
        officelocationid: null,
        devicelanip: null,
        connectiontypeid: null,
        isfingerprint: true,
        isrfid: true,
        isfaceid: false,
        devicemodeltypeid: null,
        manufaturecompanyid: null,
        ispush: true,
        ismultiplesubscription: false,
        devicestatusid: 2,
      },
      deviceserialnumber: null,
      notUnique: false,
      ErName: false,
      isloading: true,
    };

    this.getDeviceList = this.getDeviceList.bind(this);
    this.getParticularDevice = this.getParticularDevice.bind(this);
    this.getDevicePingAlert = this.getDevicePingAlert.bind(this);
    this.getDeviceGroupList = this.getDeviceGroupList.bind(this);
    this.getInitDeviceList = this.getInitDeviceList.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.openDeviceGroup = this.openDeviceGroup.bind(this);
    this.openMapDevice = this.openMapDevice.bind(this);
    this.getNumberOfEmp = this.getNumberOfEmp.bind(this);
    // this.changeStatus = this.changeStatus.bind(this);
    this.selectMenu = this.selectMenu.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
    this.showAllEmployee = this.showAllEmployee.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.createDevice = this.createDevice.bind(this);
    this.getAllCompanyLocations = this.getAllCompanyLocations.bind(this);
    this.openInfoDrawer = this.openInfoDrawer.bind(this);
    this.closeInfoDrawer = this.closeInfoDrawer.bind(this);
    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getManufacturerList = this.getManufacturerList.bind(this);
    this.getModelList = this.getModelList.bind(this);

    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    this.getDeviceList();
    this.getAllCompanyLocations();
  }

  openInfoDrawer() {
    this.setState({
      infodrawer: true,
    });
  }

  closeInfoDrawer() {
    this.setState({
      infodrawer: false,
    });
  }

  // getTabBasedForm = () => {
  //   const { postData, allData } = this.state;
  //   return (
  //     <div>
  //       <Details
  //         postData={postData}
  //         submit={this.submit}
  //         allData={allData}
  //         employeeList={this.state.employeeList}
  //         {...this.props}
  //       />
  //     </div>
  //   );
  // };

  _onCreate = () => {
    this.setState({ isEdit: false });
    this.getManufacturerList();
    this._setEditPage();
  };

  _setEditPage = () => {
    const { match } = this.props;
    this.props.history.push(`${match.path}/create`);
  };

  onEdit = (biometricdeviceid) => {
    instance
      .get(`biometric/getbiometricdevice/${biometricdeviceid}`)
      .then((response) => {
        const result = response.data.result[0];
        delete result.firmware;

        delete result.firmware;
        delete result.deviceport;
        delete result.deviceadmsip;
        delete result.deviceadmsport;
        delete result.devicedirection;
        delete result.addeddate;
        delete result.addedbyname;
        delete result.addedbyimagepath;
        delete result.updateddate;
        delete result.updatedbyname;
        delete result.updatedbyimagepath;

        (result.ispush = true),
          (result.ismultiplesubscription = false),
          this.setState({ postData: result, isEdit: true }, () => {
            this._setEditPage();
            this.getManufacturerList();
            this.getModelList(result.manufaturecompanyid);
          });
      });
  };

  checkUniqueSerialNumber1() {
    const data = {
      deviceserialnumber: this.state.postData.deviceserialnumber,
      biometricdeviceid: this.state.isEdit
        ? this.state.currentdevice.biometricdeviceid
        : null,
      isglobal: false,
    };
    instance
      .post("biometric/checkuniquedeviceserialnumber", data)
      .then((result) => {
        if (!result.data.result[0].isunique) {
          this.props.enqueueSnackbar(
            "This same device is used by another company for their Biometric Clockins, this can impact your attendance logs. Do you want to continue?",
            {
              variant: "error",
            },
          );
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleBlur(value, key) {
    const { postData } = this.state;
    if (value) {
      if (key == "deviceserialnumber") {
        instance
          .post("biometric/checkuniquedeviceserialnumber", {
            deviceserialnumber: this.state.postData.deviceserialnumber,
            biometricdeviceid: this.state.isEdit
              ? this.state.currentdevice.biometricdeviceid
              : null,
            isglobal: false,
          })
          .then((result) => {
            postData[key] = value;
            this.setState({ postData });
          })
          .catch((error) => {
            postData[key] = "";
            this.setState({ postData });
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      } else {
        instance
          .post("biometric/checkuniquedevicename", {
            devicename: this.state.postData.devicename,
            biometricdeviceid: this.state.isEdit
              ? this.state.currentdevice.biometricdeviceid
              : null,
            officelocationid: this.state.isEdit
              ? this.state.postData.officelocationid
              : null,
          })
          .then((result) => {
            postData[key] = value;
            this.setState({ postData });
          })
          .catch((error) => {
            postData[key] = "";
            this.setState({ postData });
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      }
    }
  }

  OnNameChange = (e) => {
    this.setState({ deviceserialnumber: e.target.value });
  };

  HelperSliderFlag(HtField) {
    //const text = get(this.props, `Language.attendancedevicepolicy[${HtField}]`);
    // let text = this.props.Language.attendancedevicepolicy[HtField]
    this.props.setHelperText({ helperText: "abcd" });
  }

  _renderForm = () => {
    const { postData } = this.state;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    return (
      <IntlProvider>
        <div>
          <Grid container>
            <Grid item sm={12} md={6}>
              <p className="large-text-dark t-bold margin-bottom-24">
                Add biometric device
              </p>
              {/* <DynamicForm
                fields={textinputconverter({
                  value: postData.devicename,
                  placeholder: "Enter device name",
                  label: "Device name",
                })}
                onChange={(value) => {
                  this.handleChange("devicename", value);
                }}
              /> */}

              <DynamicForm
                fields={textinputconverter({
                  value: postData.devicename,
                  placeholder: "Enter device name",
                  label: "Device name",
                })}
                onChange={(value) => {
                  this.handleChange("devicename", value);
                }}
                // onBlur={(value) => {
                //   this.handleBlur(value.target.value, "devicename");
                // }}
              />
              <p className="t-bold normal-dark">Usage</p>

              <DynamicForm
                fields={selectinputconverter({
                  value: postData.officelocationid,
                  options: this.state.locationlist,
                  placeholder: "select location",
                  label: "Office Location",
                })}
                onChange={(id) => this.handleChange("officelocationid", id)}
              />

              <DynamicForm
                fields={selectinputconverter({
                  value: postData.devicedirectionid,
                  options: directions,
                  placeholder: "Select direction",
                  label: "Direction",
                })}
                onChange={(selectedid) => {
                  this.handleChange("devicedirectionid", selectedid);
                }}
              />

              <p className="input-label">
                Which methods of clock-in/out are allowed using this device?
              </p>
              <div className="display-flex">
                <div>
                  <DynamicForm
                    fields={checkboxinputconverter({
                      value: postData && postData.isfingerprint,
                      placeholder: "",
                      label: "Fingerprint",
                    })}
                    onChange={(value) => {
                      this.handleChange("isfingerprint", value);
                    }}
                  />
                </div>
                <div className="margin-left-32">
                  <DynamicForm
                    fields={checkboxinputconverter({
                      value: postData && postData.isrfid,
                      placeholder: "",
                      label: "RFID Card",
                    })}
                    onChange={(value) => {
                      this.handleChange("isrfid", value);
                    }}
                  />
                </div>
                <div className="margin-left-32">
                  <DynamicForm
                    fields={checkboxinputconverter({
                      value: postData && postData.isfaceid,
                      placeholder: "",
                      label: "FaceID",
                    })}
                    onChange={(value) => {
                      this.handleChange("isfaceid", value);
                    }}
                  />
                </div>
              </div>

              <p className="t-bold normal-dark">Device</p>

              <DynamicForm
                fields={selectinputconverter({
                  value: postData.manufaturecompanyid,
                  options: this.state.manufacturerList,
                  placeholder: "Select manufacturer",
                  label: "Manufacturer",
                })}
                onChange={(selectedid) => {
                  this.handleChange("manufaturecompanyid", selectedid);
                }}
              />

              <DynamicForm
                fields={selectinputconverter({
                  value: postData.devicemodeltypeid,
                  options: this.state.models,
                  placeholder: "Select model",
                  label: "Model",
                })}
                onChange={(selectedid) => {
                  this.handleChange("devicemodeltypeid", selectedid);
                }}
              />

              <DynamicForm
                fields={textinputconverter({
                  value: postData.deviceserialnumber,
                  placeholder: "Enter serial number",
                  label: "Serial Number",
                })}
                onChange={(value) => {
                  this.handleChange("deviceserialnumber", value);
                }}
                onBlur={(value) => {
                  this.handleBlur(value.target.value, "deviceserialnumber");
                }}
              />

              <p className="input-label">Connection Type</p>

              <span className="floatleft width30">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: postData.connectiontypeid == 2,
                    label: "WIFI",
                  })}
                  onChange={() => this.handleChange("connectiontypeid", 2)}
                />
              </span>
              <span className="floatleft width50">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: postData.connectiontypeid == 1,
                    label: "LAN",
                  })}
                  onChange={() => this.handleChange("connectiontypeid", 1)}
                />
              </span>

              <div className="clear-float"></div>

              <DynamicForm
                fields={textinputconverter({
                  value: postData.devicelanip,
                  placeholder: "Enter IP",
                  label: "Connected Ethernet/WiFi IP",
                })}
                onChange={(value) => {
                  this.handleChange("devicelanip", value);
                }}
              />

              <div className="margin-top-32" style={{ clear: "both" }}>
                <Button
                  className={
                    (postData.ischeckercompleted &&
                      postData.ischeckercompleted) ||
                    (this.state.currentdevice &&
                      this.state.currentdevice.devicestatus == "Live")
                      ? "btn btn-primary-md-grey"
                      : issaveinprogress
                      ? "btn btn-primary-md-grey"
                      : "btn btn-primary-md-blue"
                  }
                  onClick={this.onSave}
                  disabled={
                    issaveinprogress ||
                    postData.ischeckercompleted ||
                    (this.state.currentdevice &&
                      this.state.currentdevice.devicestatus == "Live")
                      ? true
                      : false
                  }
                >
                  Save
                </Button>
                <Button
                  className="btn btn-secondary-md-blue margin-left-16"
                  onClick={this.onCancel}
                >
                  Cancel
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </IntlProvider>
    );
  };

  _renderComponent = () => {
    const { deviceList, tempList } = this.state;

    return (
      <div>
        {tempList && tempList.length == 0 && this._renderCreate()}
        {tempList && tempList.length > 0 && this._renderList()}
      </div>
    );
  };

  _renderCreate = () => (
    <div style={{ display: "table", height: "75vh", width: "100%" }}>
      <div className="display-table-cell vertical-middle">
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div>
              <img className="clipListEmpty" src={clipListEmpty} />
              <div
                className="t-20"
                style={{
                  lineHeight: "24px",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "#000",
                }}
              >
                You have not added any Biometric Device to sumHR yet
              </div>
            </div>
          </Grid>

          <Grid item xs={12} md={12} sm={12} style={{ textAlign: "center" }}>
            <Button
              color="primary"
              variant="contained"
              className="btn btn-primary-md-blue margin-top-24"
              onClick={this._onCreate}
            >
              GET STARTED
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  );

  _renderList = () => {
    const { teamList } = this.props;
    this.formConfig = null;

    return (
      <div>
        <div>
          <Grid container className="config-table">
            {/* <div className="margin-bottom-24 width100">
                <CallOutNew
                  classnames="bg-light-blue width100"
                  header={<span>📌 Watch & read how to configure your Biometric machine to send data to SumHR <span onClick={() => this.openInfoDrawer()} style={{
                    background: "#1e8ced",
                    color: "#fff",
                    padding: "4px 8px",
                    borderRadius: 4,
                    marginRight: 8,
                    marginLeft: 8,
                    cursor: "pointer"
                  }}>ESSL</span> <span onClick={() => this.openInfoDrawer()} style={{
                    background: "#1e8ced",
                    color: "#fff",
                    padding: "4px 8px",
                    borderRadius: 4,
                    marginRight: 8,
                    margiLeft: 8,
                    cursor: "pointer"
                  }}>BioMax</span></span>}
                  emoji=""
                  textcolor="#1e8ced"
                />
              </div> */}
            <Divider light />
            <Grid container className="">
              <Grid item xs={12} md={2} sm={12}>
                <div style={{ marginRight: 16 }}>
                  <Input
                    placeholder="Search"
                    disableUnderline
                    value={this.state.searchValue}
                    fullWidth
                    className="devicesearch"
                    onChange={this.onSearch}
                    startAdornment={
                      <InputAdornment position="start">
                        <SearchIcon color="disabled" />
                      </InputAdornment>
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={10} sm={12}>
                <Grid container justify="flex-end" direction="row">
                  <Grid>
                    <div>
                      <Button
                        variant="contained"
                        color="primary"
                        className="btn btn-primary-md-blue margin-right-16"
                        onClick={this._onCreate}
                      >
                        Add Biometric Device
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        type="button"
                        className="btn btn-secondary-md-blue margin-right-16"
                        onClick={this.openDeviceGroup}
                      >
                        Device group
                      </Button>
                      <Link
                        to={"../../../live_data/employee_device_mapping"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <Button
                          variant="contained"
                          color="primary"
                          type="button"
                          className="btn btn-primary-md-blue"
                        >
                          Map Employee
                        </Button>
                      </Link>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={12} sm={12} className="padding-top-30">
              <Table className="approvalWorkflow-table">
                <thead>
                  <tr>
                    <th style={{ fontWeight: "bold" }}>Name</th>
                    <th>Device Serial Number</th>
                    {/* <th>IP</th>
                  <th>Port</th> */}
                    <th>Data Sync Status</th>
                    <th>Online Status</th>
                    <th>Employees Registered</th>

                    <th>Location</th>
                    {/* <th>
         Group
        </th> */}
                    {/* <th>Status</th> */}
                    <th>Device Direction</th>

                    <th />
                  </tr>
                </thead>
                <tbody>
                  {this.state.deviceList.map((listItem, index) => (
                    <tr
                      style={{
                        background:
                          getFormattedDate(listItem.addeddate) == new Date()
                            ? "#dcf2f1"
                            : "",
                      }}
                    >
                      <td>
                        <span>{listItem.devicename}</span>
                      </td>
                      <td>
                        <span>
                          {listItem.deviceserialnumber
                            ? listItem.deviceserialnumber
                            : "-"}
                        </span>
                      </td>

                      {/* <td>
                      <span>{listItem.ip ? listItem.ip : "Allocating IP"}</span>
                    </td>
                    <td>
                      <span>{listItem.port ? listItem.port : "Allocating Port"}</span>
                    </td> */}
                      <td>
                        <span>
                          {listItem.devicestatus ? listItem.devicestatus : "-"}
                        </span>
                      </td>
                      <td>
                        <span
                          style={{
                            color:
                              listItem.onlinestatus == "Offline"
                                ? "#f00"
                                : listItem.onlinestatus == "Online"
                                ? "green"
                                : "rgba(1,7,9,0.7)",
                          }}
                        >
                          {listItem.onlinestatus ? listItem.onlinestatus : "-"}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: "inline-flex" }}>
                          {listItem.assignedEmployeeList &&
                          listItem.assignedEmployeeList.length > 0 ? (
                            listItem.assignedEmployeeList.map((emp) => (
                              <Tooltip
                                title={emp.employeename}
                                placement="bottom"
                              >
                                <div
                                  style={{
                                    display: "inline-block",
                                  }}
                                >
                                  <Link
                                    to={`./profile/${emp.employeeid}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <div className="inlineClass">
                                      {emp.imagepath == null ? (
                                        <img
                                          src={defaultEmp}
                                          height="56"
                                          className="team-img1"
                                          //  style={{ marginTop: -10 }}
                                        />
                                      ) : (
                                        <img
                                          src={getFormattedImageLink(
                                            emp.imagepath,
                                          )}
                                          height="56"
                                          className="team-img1"
                                          //  style={{ marginTop: -10 }}
                                        />
                                      )}
                                    </div>
                                  </Link>
                                </div>
                              </Tooltip>
                            ))
                          ) : (
                            <div> No Employee Registered </div>
                          )}
                          {listItem.assignedEmployeeList &&
                          listItem.assignedEmployeeList.length > 0 ? (
                            this.getNumberOfEmp(
                              listItem.assignedEmployeeList[0].fullcount,
                            ) > 0 ? (
                              <div
                                className="managerdrawer cursour-pointer"
                                onClick={() =>
                                  this.showAllEmployee(
                                    listItem.biometricdeviceid,
                                  )
                                }
                                style={{ marginTop: 0 }}
                              >
                                +
                                {this.getNumberOfEmp(
                                  listItem.assignedEmployeeList[0].fullcount,
                                )}
                              </div>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                      <td> {listItem.locationname}</td>
                      <td> {listItem.devicedirection}</td>
                      {/* <td>{listItem.group}</td> */}
                      {/* <td>
                {listItem.devicestatus == "Online" ? (
                  <span className="onlinestatus">
                    {" "}
                    {listItem.devicestatus}
                  </span>
                ) : (
                  <span
                    style={{
                      background: "#d50000",
                      color: "white",
                      padding: 4,
                      borderRadius: 3,
                    }}
                  >
                    {listItem.devicestatus}
                  </span>
                )}
              </td> */}
                      {/* <td>
                {listItem.devicedirection} */}
                      {/* <Select

                  onChange={(e)=>this.changeStatus(listItem,index,e)}
                  className={listItem.state == 1 && "select-active"}
                  disableUnderline
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={2}>InActive</MenuItem>
                </Select> */}
                      {/* </td> */}

                      <td>
                        <div>
                          <IconButton
                            aria-label="More"
                            buttonRef={(node1) => {
                              this[`anchorEl${index}`] = node1;
                            }}
                            onClick={() => this.onMenuClick(listItem)}
                          >
                            <MoreVertIcon />
                          </IconButton>

                          <Popper
                            open={
                              this.state.menuopen &&
                              this.state.selecteddevicegroupid ==
                                listItem.biometricdeviceid
                            }
                            anchorEl={this[`anchorEl${index}`]}
                            className="biometric-poper"
                            placement="right"
                            transition
                            disablePortal
                            style={{ zIndex: 1111, width: 218 }}
                          >
                            {({ TransitionProps, placement }) => (
                              <Grow
                                {...TransitionProps}
                                style={{
                                  transformOrigin:
                                    placement === "bottom"
                                      ? "right top"
                                      : "right bottom",
                                }}
                              >
                                <Paper>
                                  <ClickAwayListener
                                    onClickAway={this.onClickAway}
                                  >
                                    <MenuList>
                                      {menuActions.map((option) => (
                                        <MenuItem
                                          onClick={() =>
                                            this.selectMenu(option.id, listItem)
                                          }
                                        >
                                          {option.name}
                                        </MenuItem>
                                      ))}
                                    </MenuList>
                                  </ClickAwayListener>
                                </Paper>
                              </Grow>
                            )}
                          </Popper>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  };

  handleChange(key, value) {
    if (key == "manufaturecompanyid") {
      this.setState(
        { postData: { ...this.state.postData, [key]: value } },
        () => this.getModelList(value),
      );
    } else {
      this.setState({ postData: { ...this.state.postData, [key]: value } });
    }
  }

  onSave() {
    const { postData, currentdevice } = this.state;
    const { match } = this.props;

    const { issaveinprogress } = this.props.SaveInProgressReducer;

    delete postData.ischeckercompleted;

    postData.ispush = true;
    postData.ismultiplesubscription = false;

    const data = {
      deviceserialnumber: this.state.postData.deviceserialnumber,
      biometricdeviceid: this.state.isEdit
        ? this.state.currentdevice.biometricdeviceid
        : null,
      isglobal: true,
    };

    if (!postData.devicename) {
      this.props.enqueueSnackbar("Please enter device name", {
        variant: "error",
      });
    } else if (!postData.officelocationid) {
      this.props.enqueueSnackbar("Please select office location", {
        variant: "error",
      });
    } else if (!postData.devicedirectionid) {
      this.props.enqueueSnackbar("Please select device direction", {
        variant: "error",
      });
    } else if (!postData.manufaturecompanyid) {
      this.props.enqueueSnackbar("Please select manufacturer", {
        variant: "error",
      });
    } else if (!postData.devicemodeltypeid) {
      this.props.enqueueSnackbar("Please select model", {
        variant: "error",
      });
    } else if (!postData.deviceserialnumber) {
      this.props.enqueueSnackbar("Please enter device serial number", {
        variant: "error",
      });
    } else {
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        instance
          .post(`/biometric/registerbiometricdevice`, {
            devicejson: postData,
            biometricdeviceid: this.state.isEdit
              ? currentdevice.biometricdeviceid
              : null,
          })
          .then((resp) => {
            this.props.removeSaveProgress();
            this.props.enqueueSnackbar("Added successfully", {
              variant: "success",
            });

            const postData1 = {
              devicename: null,
              devicedirectionid: null,
              deviceserialnumber: null,
              officelocationid: null,
              devicelanip: null,
              connectiontypeid: null,
              isfingerprint: true,
              isrfid: true,
              isfaceid: false,
              devicemodeltypeid: null,
              manufaturecompanyid: null,
              ispush: true,
              ismultiplesubscription: false,
              devicestatusid: 2,
            };
            this.setState({ postData: postData1 });

            this.getDeviceList();
            this.props.history.push(`${match.path}`);
          })
          .catch((error) => {
            this.props.removeSaveProgress();
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      }
    }
  }

  onCancel() {
    const postData = {
      devicename: null,
      devicedirectionid: null,
      deviceserialnumber: null,
      officelocationid: null,
      devicelanip: null,
      connectiontypeid: null,
      isfingerprint: true,
      isrfid: true,
      isfaceid: false,
      devicemodeltypeid: null,
      manufaturecompanyid: null,
      ispush: true,
      ismultiplesubscription: false,
      devicestatusid: 2,
    };
    this.setState({ postData: postData, currentdevice: null });
    const { match } = this.props;
    this.props.history.push(`${match.path}`);
  }

  getDeviceList() {
    this.setState({ isloading: true }, () => {
      instance
        .get("biometric/getallbiometricdevice")
        .then((result) => {
          this.setState({
            deviceList: result.data.result,
            tempList: result.data.result,
            datareceived: true,
            isloading: false,
          });
        })
        .catch((error) => {
          this.setState({ isloading: false });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    });
  }

  getAllCompanyLocations() {
    instance
      .post(`subscription/getcompanylocationlist`, {
        isactive: true,
        limit: 100,
        offset: 0,
      })
      .then((resp) => {
        const locationlist =
          resp.data.result &&
          resp.data.result.map((x) => ({
            displayname: x.locationname,
            displayvalue: x.officeaddressid,
          }));

        this.setState({
          locationlist,
        });
      });
  }

  getParticularDevice(id) {
    instance
      .get(`biometric/getbiometricdevice/${id}`)
      .then((result) => {
        const currentdevice = {
          ...result.data.result[0],
          id,
        };

        const currentlocation = this.state.locationlist.filter(
          (item) => item.displayvalue == currentdevice.officelocationid,
        );
        currentdevice.locationname = currentlocation
          ? currentlocation[0].displayname
          : null;
        this.setState({
          currentdevice,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getDevicePingAlert(id) {
    instance
      .get(`biometric/getdevicealert/${id}`)
      .then((result) => {
        const pingalerts = {
          ...result.data.result[0],
          id,
        };

        this.setState({
          pingalerts,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getDeviceGroupList() {
    instance
      .get("biometric/getalldevicegroup")
      .then((result) => {
        this.setState({
          devicegroups: result.data.result,
          datarcv2: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getManufacturerList() {
    instance
      .get("biometric/getdevicemanufacturer")
      .then((result) => {
        this.setState({
          manufacturerList:
            result.data.result && !this.state.isEdit
              ? result.data.result.filter((device) => device.displayvalue !== 1)
              : result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getModelList(manufaturecompanyid) {
    instance
      .get(`biometric/getdevicemodel/${manufaturecompanyid}`)
      .then((result) => {
        this.setState({
          models: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getInitDeviceList() {
    instance
      .get("biometric/initdevicegroup")
      .then((result) => {
        const devicegroupList = result.data.result[0].newdevices;
        const selecteddevicegroup = result.data.result[0].addeddevices;
        this.setState({
          currentgroup: result.data.result[0],
          devicegroupList,
          selecteddevicegroup,
          datarcv1: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onSearch(e) {
    if (e.target.value != "") {
      const deviceList = this.state.tempList.filter(
        (item) =>
          item.devicename.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({ searchValue: e.target.value, deviceList });
    } else {
      this.setState({
        searchValue: e.target.value,
        deviceList: this.state.tempList,
      });
    }
  }

  openMapDevice() {}

  createDevice(flag) {
    this.setState({
      create: flag,
    });
  }

  openDeviceGroup() {
    this.setState(
      {
        open: true,
      },
      () => {
        this.getDeviceGroupList();
        this.getInitDeviceList();
      },
    );
  }

  showAllEmployee(deviceid) {
    this.props.RightDrawer({
      drawerdata: "Biometric",
      configid: deviceid,
      open: "right",
      side: true,
    });
  }

  getNumberOfEmp(count) {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  }

  // changeStatus(object,index,e){
  //   let deviceList = this.state.deviceList;
  //   let device = this.state.deviceList.find(device =>
  //     device.displayvalue == object.displayvalue);
  //   device.state = e.target.value;
  //   deviceList[index]= device;
  //   this.setState({
  //     deviceList
  //   })
  // }

  onMenuClick = (currentdevice) => {
    this.setState({
      menuopen: true,
      currentdevice,
      selecteddevicegroupid: currentdevice.biometricdeviceid,
    });
  };

  onClickAway() {
    this.setState({
      menuopen: false,
      selecteddevicegroupid: "",
    });
  }

  selectMenu(menuid, currentdevice) {
    this.setState(
      {
        menuopen: false,
        open: menuid == 1 ? true : false,
        menu: menuid,
      },
      () => {
        if (menuid == 1) {
          this.getParticularDevice(currentdevice.biometricdeviceid);
        } else if (menuid == 2) {
          this.onEdit(currentdevice.biometricdeviceid);
        }
      },
    );
  }

  closeDrawer() {
    this.setState({
      open: false,
      menu: null,
    });
  }

  render() {
    const { match } = this.props;
    return (
      // datareceived && (
      <IntlProvider locale="en">
        <div>
          <div className="">
            <div className="content-outer-wrapper-with-tab">
              {this.state.isloading ? (
                <div>
                  <CustomLoader />
                </div>
              ) : (
                <div>
                  <Switch>
                    <Route
                      exact
                      path={`${match.path}/create`}
                      render={this._renderForm}
                    />
                    <Route
                      exact
                      path={`${match.path}`}
                      render={this._renderComponent}
                    />
                    <Redirect from={`${match.path}`} to="" />
                  </Switch>
                </div>
              )}
            </div>
            <Drawer
              anchor="right"
              open={this.state.open}
              onClose={this.closeDrawer}
              classes={{
                paper: "bio-drawer",
              }}
            >
              {this.state.menu == 1 ? (
                <DeviceDetails
                  closeDrawer={this.closeDrawer}
                  getDeviceList={this.getDeviceList}
                  {...this.state}
                  {...this.props}
                />
              ) : this.state.menu == 2 ? (
                <DevicePingAlert
                  closeDrawer={this.closeDrawer}
                  getDeviceList={this.getDeviceList}
                  {...this.state}
                  {...this.props}
                />
              ) : this.state.menu == 3 ? (
                <DeviceRowData
                  closeDrawer={this.closeDrawer}
                  getDeviceList={this.getDeviceList}
                  {...this.state}
                  {...this.props}
                />
              ) : (
                this.state.datarcv1 &&
                this.state.datarcv2 && (
                  <DeviceGroup
                    closeDrawer={this.closeDrawer}
                    getDeviceList={this.getDeviceList}
                    {...this.state}
                    {...this.props}
                    getInitDeviceList={this.getInitDeviceList}
                    getDeviceGroupList={this.getDeviceGroupList}
                  />
                )
              )}
            </Drawer>

            <Drawer
              anchor="right"
              open={this.state.infodrawer}
              onClose={this.closeInfoDrawer}
              classes={{
                paper: "bio-drawer",
              }}
            ></Drawer>
          </div>
        </div>
      </IntlProvider>
      // )
    );
  }
}

// const mapStateToProps = (state) => ({
//   SaveInProgressReducer: state.SaveInProgressReducer,
// });

const mapStateToProps = (state) => ({
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSaveProgress,
      removeSaveProgress,
      RightDrawer: (data) => RightDrawer(data),
    },
    dispatch,
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(BioMetric)),
);
